import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { locationKeys } from "@/lib/query-keys";
import type { Department, District, Province } from "@/types/domain";

function unwrap<T>(res: any): T[] {
  const data = res?.data ?? res;
  return Array.isArray(data) ? data : [];
}

export function useDepartments() {
  return useQuery({
    queryKey: locationKeys.departments,
    staleTime: 1000 * 60 * 60,
    queryFn: async () => {
      const res = await fetchToBackend<any>("/departments/getAll");
      return unwrap<Department>(res);
    },
  });
}

export function useProvinces(departmentId?: number) {
  return useQuery({
    queryKey: locationKeys.provinces(departmentId),
    enabled: departmentId != null,
    staleTime: 1000 * 60 * 60,
    queryFn: async () => {
      const res = await fetchToBackend<any>(
        `/departments/provinces/${departmentId}`,
      );
      return unwrap<Province>(res);
    },
  });
}

export function useDistricts(provinceId?: number) {
  return useQuery({
    queryKey: locationKeys.districts(provinceId),
    enabled: provinceId != null,
    staleTime: 1000 * 60 * 60,
    queryFn: async () => {
      const res = await fetchToBackend<any>(
        `/departments/districts/${provinceId}`,
      );
      return unwrap<District>(res);
    },
  });
}
